"use strict";

var _toConsumableArray = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useNFTIndexerQuery = void 0;

var tslib_1 = require("tslib");

var react_1 = require("react");

var swr_1 = tslib_1.__importDefault(require("swr"));

var NFTFetchContext_1 = require("../context/NFTFetchContext");

var ErrorUtils_1 = require("../fetcher/ErrorUtils");
/**
 * Fetches on-chain NFT data and pricing for the given zNFT id
 *
 * @param contractAddresses address of the contract, if null and tokenID is passed in, a ZNFT is assumed
 * @param tokenId id of NFT to fetch blockchain information for
 * @param approved Auction status approved fetch boolean true = only approved, false = only not approved, null/undefined = any
 * @param options SWR flags and an option to load currency info
 * @returns useNFTType hook results include loading, error, and chainNFT data.
 */


function useNFTIndexerQuery(_ref) {
  var collectionAddresses = _ref.collectionAddresses,
      curatorAddress = _ref.curatorAddress,
      onlyAuctions = _ref.onlyAuctions,
      approved = _ref.approved,
      owner = _ref.owner,
      limit = _ref.limit,
      offset = _ref.offset;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  options.onErrorRetry = ErrorUtils_1.onErrorRetry;
  var fetcher = react_1.useContext(NFTFetchContext_1.NFTFetchContext);

  if (owner && curatorAddress) {
    throw new Error('Owner and curator address cannot be specified at the same time');
  }

  var nftListData = swr_1.default(!options.initialData && collectionAddresses ? ['useNFTIndexerGroup', owner, onlyAuctions, approved, curatorAddress, limit, offset].concat(_toConsumableArray(collectionAddresses)) : null, function (_, owner, onlyAuctions, approved, curatorAddress, limit, offset) {
    for (var _len = arguments.length, collectionAddresses = new Array(_len > 7 ? _len - 7 : 0), _key = 7; _key < _len; _key++) {
      collectionAddresses[_key - 7] = arguments[_key];
    }

    if (owner) {
      return fetcher.fetchZoraIndexerUserOwnedNFTs({
        collectionAddresses: collectionAddresses,
        userAddress: owner,
        limit: limit,
        offset: offset
      });
    }

    return fetcher.fetchZoraIndexerGroupData({
      collectionAddresses: collectionAddresses,
      curatorAddress: curatorAddress,
      approved: approved,
      onlyAuctions: onlyAuctions,
      limit: limit || 200,
      offset: offset || 0
    });
  }, options);
  return {
    error: nftListData.error,
    results: nftListData.data
  };
}

exports.useNFTIndexerQuery = useNFTIndexerQuery;